import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDe = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	style: {
		width: ".83em",
		height: ".5em"
	},
	viewBox: "0 0 5 3",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			id: "black_stripe",
			width: 5,
			height: 3,
			y: 0,
			x: 0,
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "red_stripe",
			width: 5,
			height: 2,
			y: 1,
			x: 0,
			fill: "#D00"
		}),
		/* @__PURE__ */ _jsx("rect", {
			id: "gold_stripe",
			width: 5,
			height: 1,
			y: 2,
			x: 0,
			fill: "#FFCE00"
		})
	]
});
export default SvgDe;
